import React from 'react'
import classNames from 'classnames'
import { runStatusLabel } from './runStatus'

const STATUS_CLASSES: Record<string, string> = {
  succeeded: 'zocks-bg-color-success-background zocks-text-success',
  failed: 'zocks-bg-color-danger-background zocks-text-danger',
  stopped: 'zocks-bg-color-gray-200 zocks-text-gray-700',
  'partial-succeeded': 'zocks-bg-color-warning zocks-text-warning-dark',
  running: 'zocks-bg-color-primary-light zocks-text-primary',
  scheduled: 'zocks-bg-color-primary-light zocks-text-primary',
  paused: 'zocks-bg-color-warning zocks-text-warning-dark',
}

const DEFAULT_CLASS = 'zocks-bg-color-gray-200 zocks-text-gray-700'

export const WorkflowRunStatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span className={classNames('d-inline-flex align-items-center button-small px-2 py-1 rounded-1', STATUS_CLASSES[status] ?? DEFAULT_CLASS)}>
    {runStatusLabel(status)}
  </span>
)
